import React from 'react';
import { useKanbanStore } from 'src/features/kanban';
import { KanbanState } from 'src/features/kanban/store/types';
import { shallow } from 'zustand/shallow';

import { AssigneeChart } from './AssigneeChart';
import { AssigneeWorkload, CompletionStatus, TaskColumnStatus, TaskCountAssignee } from './charts';
import { Chip } from './Chip';
import {
  getCompletedTasks,
  getIncompleteTasks,
  getOverDueTasks,
  getTotalTasks,
  groupTasksByAssignees,
} from './utils';

export const Analytics = () => {
  const { columns } = useKanbanStore(boardSelector, shallow);

  const completedTasks = getCompletedTasks(columns);
  const incompletedTasks = getIncompleteTasks(columns);
  const totalTasks = getTotalTasks(columns);
  const overDueTasks = getOverDueTasks(columns);

  const groupedTasks = groupTasksByAssignees(columns);

  return (
    <div className="max-w-1180 mx-auto bg-gray-100 min-h-full p-32">
      <div className="flex mb-32">
        <Chip icon="✅" number={completedTasks} label="Completed tasks" />
        <Chip icon="❗️" number={overDueTasks} label="Overdue tasks" />
        <Chip icon="🚫" number={incompletedTasks} label="Incomplete tasks" />
        <Chip icon="🔢" number={totalTasks} label="Total tasks" />
      </div>
      <div className="grid grid-cols-2 gap-y-30" style={{ width: '1100px' }}>
        <CompletionStatus data={columns} />
        <TaskCountAssignee data={columns} />
        <TaskColumnStatus data={columns} />
        <AssigneeWorkload data={columns} />
        {groupedTasks.map((group) => (
          <AssigneeChart
            key={group.assignee?.memberId}
            data={columns}
            assignee={group.assignee}
            tasks={group.tasks}
          />
        ))}
      </div>
    </div>
  );
};

const boardSelector = (state: KanbanState) => ({
  columns: state.columns,
});
